export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-3xl p-8 md:p-12 border border-background-200/70 text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              移动吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-md mx-auto">
              随时随地畅享51吃瓜官网全部内容，手机浏览器访问体验流畅，
              添加到桌面即可像App一样使用。51吃瓜爆料，掌上随时看。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
              <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-3 border border-background-200/70">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-xl text-primary-500"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">手机浏览器访问</div>
                  <div className="text-sm font-medium text-foreground-800">m.51chigua.com</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-3 border border-background-200/70">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-add-box-line text-xl text-accent-500"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">添加到桌面</div>
                  <div className="text-sm font-medium text-foreground-800">一键快速访问</div>
                </div>
              </div>
            </div>

            <a
              href="#"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <i className="ri-download-line text-lg"></i>
              立即体验移动版
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}